export const CREDENTIAL_LABEL_SOURCE_GENERATED = 'generated';
export const CREDENTIAL_LABEL_SOURCE_MANUAL = 'manual';

export const CREDENTIAL_LABEL_SOURCES = [CREDENTIAL_LABEL_SOURCE_GENERATED, CREDENTIAL_LABEL_SOURCE_MANUAL];

export const normalizeCredentialLabelSource = (value) => {
  const normalized = String(value || '').trim();

  if (CREDENTIAL_LABEL_SOURCES.includes(normalized)) {
    return normalized;
  }

  return '';
};
